import { render, staticRenderFns } from "./recycleModel.vue?vue&type=template&id=5964ce62&scoped=true"
import script from "./recycleModel.vue?vue&type=script&lang=js"
export * from "./recycleModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5964ce62",
  null
  
)

export default component.exports